<template>
  <div class="login-wrap">
    <div class="ms-login">
      <div class="ms-title">管理后台</div>
      <el-form :model="param" :rules="rules" ref="login" label-width="0px" class="ms-content">
        <el-form-item prop="username">
          <el-input v-model="param.username" placeholder="username">
            <el-button slot="prepend" icon="el-icon-lx-people"></el-button>
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input type="password" placeholder="password" v-model="param.password" @keyup.enter.native="submitForm()">
            <el-button slot="prepend" icon="el-icon-lx-lock"></el-button>
          </el-input>
        </el-form-item>
        <div class="login-btn">
          <el-button type="primary" @click="submitForm()">登录</el-button>
        </div>
        <p class="login-tips">Tips: 懒得理你。。。</p>
      </el-form>
    </div>
  </div>
</template>

<script>
import { adminLogin, adminPermissions } from "@/api/admin";
import { setStorage } from "@/utils/helper";
export default {
  data: function () {
    return {
      param: {
        username: "",
        password: "",
      },
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
    };
  },
  created() {
    //  console.log("地址",this.$route.query,'url',)
  },
  methods: {
    submitForm() {
      this.$refs.login.validate((valid) => {
        if (valid) {
          adminLogin(this.param)
            .then((res) => {
              if (!res.token) {
                return
              }
              setStorage("admin_user", res);
              localStorage.setItem("admin_token", res.token);
              sessionStorage.setItem("token", res.token)
              //获取管理员权限列表
              adminPermissions({ admin_id: res.id }).then((res) => {
                // console.log("lo[gin",res);
                this.$message.success("登录成功");
                setStorage("admin_permissions", res.list);
                if (
                  this.$route.query.redirect &&
                  this.$route.query.redirect !== "/login"
                ) {

                  if (this.$route.query.redirect == "/collegeBasic") {
                    let host = location.host
                    let protocol = location.protocol
                    // let host = ''
                    // if (location) {
                    //   if (location.host.includes('admin.kaoyanbox.com')) {
                    //     host = 'http://admin.kaoyanbox.com/collegeBasic'
                    //   } else {
                    //     host = 'http://localhost:8081/collegeBasic'
                    //     // host = 'http://admin.kaoyanbox.com/collegeBasic'
                    //   }
                    // }
                    window.location.href = this.$route.query.redirect+`?token=${ localStorage.getItem("admin_token")}`

                    // console.log("url",this.$route.query.redirect+`?token=${ localStorage.getItem("admin_token")}`)
                    // window.open(`${host}?token=${ localStorage.getItem("admin_token")}`)
                    // console.log("uirl",protocol + '//' + host + this.$route.query.redirect+`?token=${ localStorage.getItem("admin_token")}`)
                    return false
                  }
                  this.$router.push(this.$route.query.redirect);
                } else {
                  this.$router.push("/dashboard");
                }
              });


            })
            .catch((error) => {
              console.log(error);
              // this.$message.error(error)
            });
        } else {
          this.$message.error("请输入账号和密码");
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>
.login-wrap {
  position: relative;
  width: 100%;
  height: 100%;
  background-image: url(../assets/img/login-bg.jpg);
  background-size: 100%;
}

.ms-title {
  width: 100%;
  line-height: 50px;
  text-align: center;
  font-size: 20px;
  color: #fff;
  border-bottom: 1px solid #ddd;
}

.ms-login {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 350px;
  margin: -190px 0 0 -175px;
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.3);
  overflow: hidden;
}

.ms-content {
  padding: 30px 30px;
}

.login-btn {
  text-align: center;
}

.login-btn button {
  width: 100%;
  height: 36px;
  margin-bottom: 10px;
}

.login-tips {
  font-size: 12px;
  line-height: 30px;
  color: #fff;
}
</style>
